export default "__VITE_ASSET__BP22Q7vj__"